import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { MV_AUTH_TOKEN_STORAGE_KEY } from './vb-lxp-auth.service';

export const mvAuthGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const storageKey = (route.data?.['authStorageKey'] as string) || MV_AUTH_TOKEN_STORAGE_KEY;
	const redirectTo = (route.data?.['authRedirectTo'] as string) || '/login';
	const token = localStorage.getItem(storageKey);

	if (token) {
		return true;
	}

	return router.createUrlTree([redirectTo], {
		queryParams: { returnUrl: state.url },
	});
};
